export default __webpack_public_path__ + "static/Newsletter_background_people-be1a384a1d5851362b05637ea4204dac.png";